<div class="box-conditional-offer-bid" *ngIf="leadSent">
  <div class="row">
    <div class="col-md-2">
      <i class="fa-solid fa-check-circle" style="font-size: 39px; color: var(--title-color-alt)"></i>
    </div>
    <div class="col-md-10 pl-4">
      <div class="row">
        <span class="title" [style.color]="menuColorNotWhite">Mensagem enviada com sucesso!</span>
      </div>
      <div class="row">
        <span class="subtitle">Agradecemos seu contato. Nossa equipe retornará em breve.</span>
      </div>
    </div>
  </div>
</div>

<!-- Mensagem inicial -->
<div *ngIf="!showForm && !leadSent && !disableConfirmationModal && transactional" class="custom-offer-initial-message">
  <div>
    <div>
      Gostaria de mais informações?
    </div>
    <a href="#" (click)="showForm = true; $event.preventDefault();">
      Envie uma mensagem
    </a>
  </div>
</div>

<!-- Formulário (já existente) -->
<div class="box-lead" *ngIf="(showForm || disableConfirmationModal || !transactional) && !leadSent">
  <div class="row">
    <div class="col-md-12">
      <div class="title-box" [style.color]="menuColorNotWhite">
        <span class="material-icons" style="margin-right: 8px">send</span>
        ENVIAR MENSAGEM
      </div>
    </div>
    <div class="col-md-12" *ngIf="vehicle.bidOption === 'NONE'">
      <div class="value" [style.color]="menuColorNotWhite">
        <span class="currency-symbol">R$ </span>
        {{ vehicle.currentPrice | number }}
      </div>
    </div>

    <div class="col-md-12 error-message" *ngIf="errorMessage">
      Houve um problema com a sua mensagem:<br />
      {{ errorMessage }}
    </div>

    <form [formGroup]="leadForm" class="col-md-12">
      <div class="form-group">
        <label for="name">Nome*</label>
        <input
          type="text"
          class="form-control"
          [class.is-invalid]="leadForm.get('name').invalid && leadForm.get('name').touched"
          id="name"
          formControlName="name"
        />
        <div class="invalid-feedback" *ngIf="leadForm.get('name').invalid && leadForm.get('name').touched">Campo obrigatório</div>
      </div>

      <div class="form-group">
        <label for="email">E-mail*</label>
        <input
          type="email"
          class="form-control"
          [class.is-invalid]="leadForm.get('email').invalid && leadForm.get('email').touched"
          id="email"
          formControlName="email"
        />
        <div class="invalid-feedback" *ngIf="leadForm.get('email').invalid && leadForm.get('email').touched">
          <span *ngIf="leadForm.get('email').errors?.required">Campo obrigatório</span>
          <span *ngIf="leadForm.get('email').errors?.email">E-mail inválido</span>
        </div>
      </div>

      <div class="form-group">
        <label for="phoneNumber">Telefone*</label>
        <input
          type="tel"
          class="form-control"
          [class.is-invalid]="leadForm.get('phoneNumber').invalid && leadForm.get('phoneNumber').touched"
          id="phoneNumber"
          formControlName="phoneNumber"
        />
        <div class="invalid-feedback" *ngIf="leadForm.get('phoneNumber').invalid && leadForm.get('phoneNumber').touched">Campo obrigatório</div>
      </div>

      <div class="form-group" *ngIf="vehicle.leadGenerationCollectCpfCnpj">
        <label for="cpfCnpj">CPF/CNPJ*</label>
        <input
          type="text"
          class="form-control"
          [class.is-invalid]="leadForm.get('cpfCnpj').invalid && leadForm.get('cpfCnpj').touched"
          id="cpfCnpj"
          formControlName="cpfCnpj"
          mask="AA.AAA.AAA/AAAA-00||000.000.000-00"
          [dropSpecialCharacters]="true"
        />
        <div class="invalid-feedback" *ngIf="leadForm.get('cpfCnpj').invalid && leadForm.get('cpfCnpj').touched">
          <span *ngIf="leadForm.get('cpfCnpj').errors?.required">Campo obrigatório</span>
          <span *ngIf="leadForm.get('cpfCnpj').errors?.cpf">CPF/CNPJ inválido</span>
        </div>
      </div>

      <div class="form-group">
        <label for="message">Mensagem</label>
        <textarea class="form-control" id="message" rows="3" formControlName="message"></textarea>
      </div>

      <div class="form-group">
        <div class="invalid-feedback" *ngIf="!recaptchaCompleted && recaptchaTouched">Por favor, aguarde a verificação do reCAPTCHA</div>
      </div>

      <div class="col-md-12 mt-4">
        <button 
          class="btn btn-primary btn-rounded btn-block btn-lg" 
          (click)="sendLead()"
          [disabled]="leadForm.disabled">
          ENVIAR
        </button>
      </div>
    </form>
  </div>
</div>
